/**
 * Read confirmed full-cart CDS consumption without converting points into currency.
 * @param {object} purchase - Persisted purchase fields.
 * @returns {string|number|null} Exact consumed amount, or null before settlement.
 */
export default function getCompletedCdsPointsUsed(purchase) {
  const amount = purchase.cdsPointsUsed;
  return purchase.state === 'completed' &&
    purchase.usesCdsPoints === true &&
    Number.isFinite(Number(amount)) &&
    Number(amount) > 0
    ? amount
    : null;
}
